import { render, staticRenderFns } from "./RecipeUpdateUserFoodPrice.vue?vue&type=template&id=732af24e&scoped=true"
import script from "./RecipeUpdateUserFoodPrice.vue?vue&type=script&lang=js"
export * from "./RecipeUpdateUserFoodPrice.vue?vue&type=script&lang=js"
import style0 from "./RecipeUpdateUserFoodPrice.vue?vue&type=style&index=0&id=732af24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732af24e",
  null
  
)

export default component.exports